import { trackEvent } from "../../../utils/EventTrackingUtil";

const entrypoint_to_name_map = {
  hcp_signup: "hcp",
  referral_signup: "referred-patient-registration",
  self_signup: "digital-direct",
  teens_kids_program: "teens-and-kids",
};

const generic_messages = {
  accepted: {
    copay: "-eligibility-accepted-with-copay",
    nocopay: "-eligibility-accepted-without-copay",
  },
  declined: "-eligibility-declined",
  no_match: "-eligibility-no-match-",
  not_configured: "-eligibility-not-configured",
  pending: "-eligibility-pending-",
};

const generic_click_messages = {
  // back to insurance screen or clicking link to payers site
  declined: {
    back: "-back-to-insurance",
    payor: "-click-payer-site",
  },
  no_match: {
    call: "-call-support",
    email: "-email-support",
  },
  pending: {
    call: "-call-support",
    email: "-email-support",
  },
};

const format_message_by_entrypoint = ({ copay, entryPoint, status, submissionAttempts }) => {
  let message;
  let ga_name = entrypoint_to_name_map[entryPoint];

  if (status === "accepted") {
    message = copay
      ? ga_name + generic_messages[status]["copay"]
      : ga_name + generic_messages[status]["nocopay"];
  } else {
    message = ga_name + generic_messages[status];
  }

  if (status === "no_match" || status === "pending") {
    message = message + submissionAttempts;
  }

  return message;
};

const format_message_by_entrypoint_click = (entryPoint, status, clickOrigin) => {
  let message = entrypoint_to_name_map[entryPoint];

  message += "-" + status.replace("_", "-");
  message += generic_click_messages[status][clickOrigin];

  return message;
};

export const analytics = ({ entryPoint, patientEligibility, submissionAttempts }) => {
  const status = patientEligibility["status"];
  const copay = patientEligibility["copay"];
  const message = format_message_by_entrypoint({ copay, entryPoint, status, submissionAttempts });

  trackEvent(message);
};

//click origin is the click events next step: back (i.e. going back to fix ins), payor (clicking payors site), email (apti), call (apti)
export const clickAnalytics = (entryPoint, status, clickOrigin) => {
  const message = format_message_by_entrypoint_click(entryPoint, status, clickOrigin);

  trackEvent(message);
};
